<template>
  <div id="fotter">
    <p style="color: white;height: 30px;line-height: 30px;width: 850px;margin: 0px auto">
      <span style="vertical-align: middle;">Copyright 2022-2023 </span>
      <img src="../../static/img/logo.png" class="logo" style="vertical-align: middle;">
      <span class="span"><a href="http://gsztjc.gslq.com/" style="vertical-align: middle;"
          class="a">甘肃智通科技工程检测咨询有限公司</a></span>
      <span style="vertical-align: middle;">All Rights Reserved</span>
    </p>
  </div>
</template>

<script>
export default {
  name: "FooterBar"
}
</script>

<style scoped>
#fotter {
  position: absolute;
  bottom: 0px;
  margin-left: 30%;
  height: 5%;
}
.logo {
  width: 30px;
  height: 30px;
}
.a {
  color: white;
  text-decoration: none;
}
.span {
  height: 30px;
  line-height: 30px;
}
</style>



// WEBPACK FOOTER //
// src/components/FooterBar.vue